import { MenuItem, Typography } from "@mui/material";
import { useContext } from "react";
import useLocales from "src/hooks/useLocales";

import Context from "../context";
import SortItem from "./SortItem";

// ----------------------------------------------------------------------

type Props = {
	id: string;
};

export default function DisableSortItem({ id }: Props) {
	const { actions, orderBy } = useContext(Context);
	const { translate } = useLocales();

	const onClick = (event: any) => {
		event.stopPropagation();
		actions.onSort!(undefined);
	};

	return !orderBy || orderBy !== id ? (
		<SortItem direction={"desc"} id={id} />
	) : (
		<MenuItem onClick={onClick} sx={{ px: 1 }}>
			<Typography variant='body2'>{translate("Sin orden")}</Typography>
		</MenuItem>
	);
}
